(function () {
    "use strict";

    let modelViewerPromise = null;

    function loadModelViewerLibrary() {
        if (modelViewerPromise) {
            return modelViewerPromise;
        }

        modelViewerPromise = new Promise((resolve, reject) => {
            if (customElements.get('model-viewer')) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.type = 'module';
            script.src = (window.NS_OBJ && window.NS_OBJ.model_viewer_lib)
                ? window.NS_OBJ.model_viewer_lib
                : 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';

            script.onload = () => {
                resolve();
            };
            script.onerror = (err) => {
                console.error('Failed to load model-viewer script', err);
                modelViewerPromise = null; // Reset promise to allow retrying later
                reject(err);
            };

            document.head.appendChild(script);
        });

        return modelViewerPromise;
    }

    // Listen to bootstrap modal show event when opening a 3d mockup modal
    document.addEventListener('show.bs.modal', function (event) {
        const modal = event.target;
        if (!modal || !modal.classList.contains('view-3d-modal')) {
            return;
        }

        const modelSrc = modal.getAttribute('data-model-src');
        const modelPoster = modal.getAttribute('data-model-poster');
        const modelUsdz = modal.getAttribute('data-model-usdz');
        const autoRotate = modal.getAttribute('data-model-auto-rotate') !== 'false';
        const cameraControls = modal.getAttribute('data-model-camera-controls') !== 'false';
        const ar = modal.getAttribute('data-model-ar') !== 'false';

        if (!modelSrc) {
            return;
        }

        const container = modal.querySelector('#modal-3d-view-inner');
        if (!container) {
            return;
        }

        const spinner = container.querySelector('.spinner');
        const existingModelViewer = container.querySelector('model-viewer');
        if (spinner) {
            if (!existingModelViewer || !existingModelViewer.loaded) {
                spinner.style.display = 'block';
            } else {
                spinner.style.display = 'none';
            }
        }

        // Load model-viewer library dynamically
        loadModelViewerLibrary()
            .then(() => {
                let modelViewer = container.querySelector('model-viewer');
                if (!modelViewer) {
                    const objContent = container.querySelector('.obj_content');
                    if (objContent) {
                        objContent.innerHTML = '';

                        modelViewer = document.createElement('model-viewer');
                        modelViewer.setAttribute('src', modelSrc);
                        if (modelPoster) {
                            modelViewer.setAttribute('poster', modelPoster);
                        }
                        if (modelUsdz) {
                            modelViewer.setAttribute('ios-src', modelUsdz);
                        }

                        // Set visual presentation options based on product settings
                        if (cameraControls) {
                            modelViewer.setAttribute('camera-controls', '');
                        }
                        if (autoRotate) {
                            modelViewer.setAttribute('auto-rotate', '');
                            modelViewer.setAttribute('rotation-per-second', '40deg');
                        }
                        modelViewer.setAttribute('shadow-intensity', '1');
                        modelViewer.setAttribute('environment-image', 'neutral');
                        if (ar) {
                            modelViewer.setAttribute('ar', '');
                        }

                        modelViewer.style.width = '100%';
                        modelViewer.style.height = '500px';
                        modelViewer.style.display = 'block';

                        modelViewer.addEventListener('load', () => {
                            if (spinner) {
                                spinner.style.display = 'none';
                            }
                        });

                        modelViewer.addEventListener('error', (e) => {
                            console.error('Error loading 3D model:', e);
                            if (spinner) {
                                spinner.style.display = 'none';
                            }
                            objContent.innerHTML = '<div class="alert alert-danger text-center">' +
                                (window.NS_OBJ && window.NS_OBJ.i18n && window.NS_OBJ.i18n.an_error ? window.NS_OBJ.i18n.an_error : 'Error loading 3D model') +
                                '</div>';
                        });

                        objContent.appendChild(modelViewer);

                        // Setup controls listeners
                        const playPauseBtn = container.querySelector('.mockup-btn-play-pause');
                        const zoomInBtn = container.querySelector('.mockup-btn-zoom-in');
                        const zoomOutBtn = container.querySelector('.mockup-btn-zoom-out');
                        const resetBtn = container.querySelector('.mockup-btn-reset');

                        // Update initial play/pause icon state based on settings
                        if (playPauseBtn) {
                            const icon = playPauseBtn.querySelector('i');
                            if (icon) {
                                if (autoRotate) {
                                    icon.className = 'fi fi-sr-pause';
                                } else {
                                    icon.className = 'fi fi-sr-play';
                                }
                            }

                            playPauseBtn.addEventListener('click', function () {
                                const icon = playPauseBtn.querySelector('i');
                                if (modelViewer.hasAttribute('auto-rotate')) {
                                    modelViewer.removeAttribute('auto-rotate');
                                    if (icon) icon.className = 'fi fi-sr-play';
                                } else {
                                    modelViewer.setAttribute('auto-rotate', '');
                                    if (icon) icon.className = 'fi fi-sr-pause';
                                }
                            });
                        }

                        if (zoomInBtn) {
                            zoomInBtn.addEventListener('click', function () {
                                if (typeof modelViewer.zoom === 'function') {
                                    modelViewer.zoom(1);
                                }
                            });
                        }

                        if (zoomOutBtn) {
                            zoomOutBtn.addEventListener('click', function () {
                                if (typeof modelViewer.zoom === 'function') {
                                    modelViewer.zoom(-1);
                                }
                            });
                        }

                        if (resetBtn) {
                            resetBtn.addEventListener('click', function () {
                                modelViewer.cameraOrbit = 'auto auto auto';
                                modelViewer.cameraTarget = 'auto auto auto';
                                modelViewer.fieldOfView = 'auto';
                            });
                        }
                    }
                }
            })
            .catch((err) => {
                if (spinner) {
                    spinner.style.display = 'none';
                }
                const objContent = container.querySelector('.obj_content');
                if (objContent) {
                    objContent.innerHTML = '<div class="alert alert-danger text-center">Failed to load 3D engine.</div>';
                }
            });
    });
})();
